import { apiClient } from "./api";
export const droneService = {
    getAll: async () => {
        const response = await apiClient.get("/fleet/drones/");
        return response.data;
    },
    getById: async (id) => {
        const response = await apiClient.get(`/fleet/drones/${id}/`);
        return response.data.data;
    },
    create: async (data) => {
        const response = await apiClient.post("/fleet/drones/", data);
        return response.data.data;
    },
    update: async (id, data) => {
        const response = await apiClient.patch(`/fleet/drones/${id}/`, data);
        return response.data.data;
    },
    delete: async (id) => {
        await apiClient.delete(`/fleet/drones/${id}/`);
    },
    getStats: async () => {
        const response = await apiClient.get("/fleet/stats/");
        return response.data;
    },
};
